export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const calculateAffiliateCommission = (commissionRate, basePrice) => {
  const total = (commissionRate / 100) * basePrice;
  return total.toFixed(2);
}
